import React from "react";
import { useDispatch } from "react-redux/es/hooks/useDispatch";
import { useI18N } from "@src/language/language-context";
import requestTechnicalSupportIcon from "@src/assets/svg/support-screen-icon.svg";
import {
  updateAddRequestTechnicalSupportDrawerModal,
  updateModalsCloseDrawerModal,
} from "@src/reducers/your-reducer";
import { IconButton } from "../buttons/icon-button/icon-button";
import { VerticalSeparator } from "../vertical-separator/vertical-separator";

interface TicketSupportForMachineRowIconButtonProps {
  machineName: string;
  machineId: string;
}

export const TicketSupportForMachineRowIconButton = ({
  machineName,
  machineId,
}: TicketSupportForMachineRowIconButtonProps) => {
  const i18n = useI18N();
  const dispatch = useDispatch();
  const tooltip = i18n(
    "modules.ticketSupportForMachineRowIconButton.goToRequestTechnicalSupport",
  );

  if (!machineId.trim()) return null;

  const handleOpenRequestTechnicalSupportDrawerModal = () => {
    dispatch(
      updateAddRequestTechnicalSupportDrawerModal({
        machine_id: machineId,
        source_name: machineName,
      }),
    );
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: false,
        id: "supportChatDrawerModal",
      }),
    );
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "addRequestTechnicalSupportDrawerModal",
      }),
    );
  };

  return (
    <>
      <VerticalSeparator />
      <IconButton
        fun={handleOpenRequestTechnicalSupportDrawerModal}
        icon={requestTechnicalSupportIcon}
        tooltip={tooltip}
      />
    </>
  );
};
